import styled from '@emotion/styled';
import { css } from '@emotion/react';

type Props = {
    width?: string;
    height?: string;
    className?: string;
    gradientId?: string;
};

const StyledLogo = styled.svg(
    (props) => css`
        display: inline-block;
        width: ${props.width || 'auto'};
        height: ${props.height || 'auto'};
        fill: ${props.color === 'purple'
            ? props.theme.colors['primary-brand']
            : props.theme.colors.white};
    `
);

const LogoComponent = ({ width, height, gradientId, className }: Props) => {
    return (
        <StyledLogo
            width={width}
            height={height}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            viewBox={`0 0 110 20`}
            role="presentation"
            aria-hidden="true"
            data-testid="zoopla-logo"
            aria-label="Zoopla logo in rainbow colour in support of Pride"
        >
            <path
                d="M15.5725 15.984H4.30903L0.726562 19.6171H15.5725V15.984Z"
                fill="#ED5B1B"
            />
            <path
                d="M0.052963 0.382866V3.98981H11.2607C11.1521 6.69467 9.18568 7.40531 6.95037 8.16967C3.77123 9.26319 0 10.6556 0 18.1421V19.6171H0.726543L4.31037 15.984C4.41901 13.1153 6.43839 12.3509 8.72802 11.5576C8.8421 11.5177 9.04444 11.4475 9.15988 11.4061C11.6057 10.5371 14.2267 9.34444 15.161 5.3202C15.3769 4.35753 15.5168 3.14833 15.5168 1.8317V0.382866H0.052963Z"
                fill="#E81319"
            />
            <path
                d="M20.475 10.0551C20.475 6.28426 23.062 3.74466 26.4014 3.74466C29.7408 3.74466 32.3006 6.26085 32.3264 10L35.7813 6.49635C34.4626 2.55199 30.9263 0 26.4285 0C20.6895 0 16.4335 4.1537 16.4335 10.0551C16.4335 14.6991 19.0708 18.1917 22.99 19.4698L26.1882 16.2264C22.9506 16.1245 20.475 13.7199 20.475 10.0565V10.0551Z"
                fill="#ED5B1B"
            />
            <path
                d="M59.7286 0.355324V4.29968L63.6167 0.355324H59.7286Z"
                fill="#FFAA00"
            />
            <path
                d="M47.9003 16.2292C44.5595 16.2292 41.9453 13.797 41.9453 10.0551C41.9453 6.31318 44.5582 3.74466 47.9003 3.74466C51.2424 3.74466 53.7995 6.28564 53.7995 10.0551C53.7995 10.1432 53.7968 10.23 53.7941 10.3168L57.3494 6.71257C56.0878 2.64564 52.5067 0 47.9288 0C42.1911 0 37.9337 4.1537 37.9337 10.0551C37.9337 14.7831 40.6674 18.317 44.7062 19.5359L47.9668 16.2292C47.9451 16.2292 47.9233 16.2305 47.9016 16.2305L47.9003 16.2292Z"
                fill="#FFAA00"
            />
            <path
                d="M35.7826 6.49635L32.3278 10C32.3278 10.0193 32.3278 10.0372 32.3278 10.0551C32.3278 13.797 29.7421 16.2292 26.4013 16.2292C26.3294 16.2292 26.2588 16.2264 26.1881 16.2237L22.99 19.467C24.0506 19.8127 25.2063 19.9986 26.4285 19.9986C32.1662 19.9986 36.3434 15.9551 36.3434 10.0537C36.3434 8.77703 36.1479 7.58298 35.7826 6.4936V6.49635Z"
                fill="#FFAA00"
            />
            <path
                d="M82.5747 0.382866H78.5604V7.28963L82.5747 3.21856V0.382866Z"
                fill="#008536"
            />
            <path
                d="M57.3494 6.71257L53.7941 10.3168C53.6787 13.8865 51.1962 16.1975 47.9655 16.2278L44.7048 19.5345C45.7071 19.8375 46.788 19.9986 47.9288 19.9986C53.6664 19.9986 57.8437 15.9551 57.8437 10.0537C57.8437 8.86104 57.6699 7.74136 57.3508 6.70982L57.3494 6.71257Z"
                fill="#008536"
            />
            <path
                d="M99.2512 0C94.2401 0 90.0914 4.17987 90.0914 10C90.0914 12.2779 90.7283 14.3024 91.8025 15.9248L94.7358 12.9473C94.3488 12.1058 94.1315 11.1169 94.1315 9.99862C94.1315 6.25534 96.5569 3.79562 99.9778 3.79562C101.124 3.79562 102.147 4.06556 103.01 4.54758L105.074 2.45283C103.638 0.86214 101.63 0 99.2512 0Z"
                fill="#14325F"
            />
            <path
                d="M69.266 0C66.8406 0 64.8484 1.22848 63.743 3.41551V0.355323H63.618L59.7286 4.29968V19.6171H63.743V12.7324C64.8742 15.0007 66.9221 16.1479 69.266 16.1479C69.4643 16.1479 69.6585 16.1369 69.8527 16.1217C73.169 15.8449 75.9176 13.2323 76.4473 9.43396C76.507 9.00014 76.5396 8.55116 76.5396 8.08842C76.5396 3.33425 73.2247 0.00137722 69.2647 0.00137722L69.266 0ZM68.1076 12.541C65.6021 12.541 63.743 10.7644 63.743 8.08704C63.743 5.40972 65.6822 3.63311 68.1076 3.63311C70.6675 3.63311 72.5525 5.38218 72.5525 8.08704C72.5525 10.7919 70.6662 12.541 68.1076 12.541V12.541Z"
                fill="#008536"
            />
            <path
                d="M82.5747 15.984V3.21857L78.5604 7.28963V19.6171H88.1643H89.9026V17.8529V15.984H82.5747Z"
                fill="#14325F"
            />
            <path
                d="M107.151 0.382866H105.986V3.68957C105.72 3.24611 105.421 2.8412 105.091 2.47349C105.085 2.4666 105.08 2.46109 105.074 2.45558L103.01 4.55034C103.017 4.55447 103.024 4.5586 103.032 4.56273C104.878 5.60253 105.987 7.6119 105.987 10.0275C105.987 13.7171 103.429 16.1741 99.9791 16.1741C97.6542 16.1741 95.6932 15.0103 94.7453 12.9665C94.7426 12.961 94.7399 12.9541 94.7372 12.9486L91.8038 15.9262L91.8133 15.94C93.4837 18.4561 96.2079 20 99.2526 20C102.297 20 104.56 18.6613 105.987 16.2843V19.6171H110.001V0.382866H107.152H107.151Z"
                fill="#8046F1"
            />
        </StyledLogo>
    );
};

export default styled(LogoComponent)();
